import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AppConfig } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private isDarkThemeSubject = new BehaviorSubject<boolean>(false);
  public isDarkTheme$ = this.isDarkThemeSubject.asObservable();

  constructor() {
    this.initializeTheme();
  }

  private initializeTheme(): void {
    const savedTheme = localStorage.getItem('preferences.isDarkTheme');
    let isDarkTheme: boolean;
    
    if (savedTheme !== null) {
      // Use saved preference if it exists
      isDarkTheme = savedTheme === 'true';
    } else {
      // Default to dark theme for RYPPLZZ environment, light theme for others
      isDarkTheme = AppConfig.environment === 'RYPPLZZ';
    }
    
    this.isDarkThemeSubject.next(isDarkTheme);
    this.applyTheme(isDarkTheme);
  }

  public toggleTheme(): void {
    const newTheme = !this.isDarkThemeSubject.value;
    this.setTheme(newTheme);
  }

  public setTheme(isDarkTheme: boolean): void {
    this.isDarkThemeSubject.next(isDarkTheme);
    localStorage.setItem('preferences.isDarkTheme', isDarkTheme.toString());
    this.applyTheme(isDarkTheme);
  }

  public getCurrentTheme(): boolean {
    return this.isDarkThemeSubject.value;
  }

  private applyTheme(isDarkTheme: boolean): void {
    const body = document.body;
    if (isDarkTheme) {
      body.classList.add('dark-theme');
    } else {
      body.classList.remove('dark-theme');
    }
  }
}